import { useContext } from "react";
import { Navigate, Outlet, } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import { Box, Typography } from "@mui/material";

import { UserContext } from "./context/UserContext";

export default function PrivateRoute() {

    const { loading, session, } = useContext(UserContext);

    if (loading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    gap: 2,
                }}
            >
                <CircularProgress size={80} thickness={5} />

                <Typography
                    variant="h6"
                    color="text.secondary"
                >
                    Loading...
                </Typography>
            </Box>
        );
    }

    return session?.logged_in ? <Outlet /> : <Navigate to="/login" replace />;
}